module.exports = __webpack_public_path__ + "img/atention.68d78adb.jpg";